import React from "react";
import "./App.css";
import useReveal from "./hooks/useReveal";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import IntroShift from "./components/IntroShift";
import Develop from "./components/Develop";
import Program from "./components/Program";
import Testimonials from "./components/Testimonials";
import Pricing from "./components/Pricing";
import About from "./components/About";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

const Landing = () => {
  useReveal();
  return (
    <div className="ocean-bg min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <IntroShift />
        <Develop />
        <Program />
        <Testimonials />
        <Pricing />
        <About />
        <FAQSection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App;
